<template>
    <div
    ref="chipsContainer"
    class="chips-wrapper-container"
    :class="{ mobile: getMobileAppState }"
    :style="chipsContainerStyles">
        <div
        class="chip-wrapper"
        ref="chipsWrapper"
        :key="`filterKey${filters.length}`"
        v-dragscroll="hasScroll"
        v-on:dragscrollstart="grabing = true"
		v-on:dragscrollend="grabing = false"
        :style="chipsWrapperStyles"
		:class="{'grabing': grabing}">
			<!-- Chip -->
            <filter-chip
            v-for="chip in filters"
            :key="chip.id"
            :params="chip"
            @close="emit('close', $event)"/>
			<!-- Close All Chips -->
            <button-tertiary
            class="close-all-chips"
            :label="t('filters.clearFilters')"
            buttonSize="small"
            @clicked="emit('closeAll')" />
        </div>
    </div>
</template>

<script setup>
import FilterChip from '@/components/generic/buttons/chip/Chip'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
/* Vue */
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['close', 'closeAll'])

/** props received
@filters { Array } each item is an Object:
    - id { String, Number }
	- label { String}
	- text { String }
*/
const props = defineProps({
	filters: Array
})

/* mapGetters */
const { getMobileAppState } = mapGetters()

const grabing = ref(false)
const chipsContainer = ref()
const chipsWrapper = ref()
const hasScroll = ref(false)

watch(() => props.filters, () => {
    setTimeout(() => {
        scrollController()
    }, 100)
})

const scrollController = () => {
    hasScroll.value = chipsContainer.value.offsetWidth < chipsWrapper.value.scrollWidth
}

const controllersTrigger = () => {
    scrollController()
}

onMounted(() => {
    controllersTrigger()
	window.addEventListener('resize', controllersTrigger)
})

onBeforeUnmount(() => {
	window.removeEventListener('resize', controllersTrigger)
})
</script>

<style lang="scss" scoped>
.chips-wrapper-container {
    width: 100%;
    height: auto;
	position: relative;

    margin-left: 16px;

    display: flex;
	align-items: center;
    align-self: flex-start;
	flex-shrink: 0;

	overflow: visible;

    .chip-wrapper {
        width: fit-content;
        height: 80px;
        gap: 8px;

		margin-left: calc(2 * -16px);
		padding-left: 16px;

        display: flex;
        align-items: center;
        overflow: hidden;

        &.grabing {
			cursor: grabbing;
			cursor: -webkit-grabbing;
		}

        // this is more for firefox/safari, sometimes they dont give the final margin to the component
		&:after {
			content: "_";
			width: 16px;
			height: 100%;
			display: inline-block;
			visibility: hidden;
			flex-shrink: 0;
		}

        .tertiary-button-wrapper {
            flex-shrink: 0;
        }
    }
}

</style>
